import { Component } from "vue-property-decorator";
import PredefinedCustomerSelect from "@components/predefined-customer-select/predefined-customer-select";
import FacilitySelect from "@components/facility-select/facility-select";
import util from "@shared/util";
import * as XLSX from "xlsx";
import CustomerWiseVue from "@shared/customer-wise-vue";
import tlp from "./import-transload.vue";
import ReceiptService from "@services/receipt-service";

@Component({
    mixins: [tlp],
    components: {
        PredefinedCustomerSelect,
        FacilitySelect
    }
})
export default class ImportTransload extends CustomerWiseVue {
    searchParam: any = {
        customerId: '',
        facility: null
    };
    fileName: string = '';

    tableColumns: string[] = [];
    tableData: any[] = [];

    mappingFields: string[] = [
        "Reciept Type","PONo","ContainerNo","ReferenceNo","BOLNo","Seals","Carrier","SCAC Code","Item ID","Title","Supplier","Destination","Pallet/Carton No - Expected","Expected","Expected UOM","LotNo","weight","weight UOM","volume","volume UOM","Goods Type"
    ];
    fieldMapping: { [key: string]: string } = {
        "receiptType": "Reciept Type",
        "poNo": "PONo",
        "containerNo": "ContainerNo",
        "referenceNo": "ReferenceNo",
        "bolNo": "BOLNo",
        "sealNo": "Seals",
        "carrierName": "Carrier",
        "scac": "SCAC Code",
        "itemName": "Item ID",
        "titleName": "Title",
        "supplierName": "Supplier",
        "destination": "Destination",
        "cartonNo": "Pallet/Carton No - Expected",
        "qty": "Expected",
        "unit": "Expected UOM",
        "lotNo": "LotNo",
        "weight": "weight",
        "weightUnit": "weight UOM",
        "cube": "volume",
        "volumeUnit": "volume UOM",
        "goodsType": "Goods Type"
    };

    isSubmit: boolean = false;

    beforeUpload(file: File) {
        this.fileName = file.name;
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            if (Array.isArray(json) && json.length > 1) {
                this.tableColumns = json[0] as string[];
                this.tableData = (json as any[]).slice(1).map((row: any[]) => {
                    const obj: any = {};
                    this.tableColumns.forEach((col, idx) => {
                        obj[col] = row[idx];
                    });
                    return obj;
                });
                this.mappingFields.forEach(f => {
                    this.$set(this.fieldMapping, f, this.tableColumns.find(col => col.toLowerCase() === f.toLowerCase()) || '');
                });
            }
        };
        reader.readAsArrayBuffer(file);
        return false;
    }

    removeRow(idx: number) {
        this.tableData.splice(idx, 1);
    }

    onselectCustomerChange(val: any) {
        this.searchParam.customerId = val && val.id ? val.id : '';
        this.searchParam.facility = null;
    }

    onSelectFacilityChange(val: any) {
        // Facility select v-model already handles searchParam.facility
        // This can be used for additional logic if needed when facility changes
    }

    get canSubmit() {
        return this.searchParam.customerId && this.searchParam.facility && this.searchParam.facility.id && this.tableData.length > 0 && this.mappingFields.every(f => this.fieldMapping[f]);
    }

    onSubmit() {
        this.isSubmit = true; // Indicate submission is in progress

        // Set customerId for each entry in tableData
        this.tableData.forEach(entry => {
            entry.customerId = this.searchParam.customerId;

            // Apply the latest user-configured mapping
            Object.keys(this.fieldMapping).forEach(key => {
                const mappedField = this.fieldMapping[key];
                if (mappedField && entry[mappedField] !== undefined) {
                    entry[key] = typeof entry[mappedField] === 'string' ? entry[mappedField].trim() : entry[mappedField];
                }
            });
        });

        // Call the new API endpoint using ReceiptService
        ReceiptService.importTransloadReceipt(this.tableData)
            .subscribe(
                (response: any) => {
                    this.isSubmit = false; // Reset submission status
                    util.popUpSucceedMessage(`Import successful! Receipt ID: ${response.receiptId}`);
                },
                (err: any) => {
                    this.isSubmit = false; // Reset submission status
                    this.error(err);
                }
            );
    }
}
